"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("@common/configuration");
const units_service_1 = require("./units.service");
class UnitListingDescriptionService extends units_service_1.UnitsService {
    constructor(token) {
        super(token);
        this.endpointBaseUrlV2 = configuration_1.Configuration.unitsServiceConfig().apiV2;
    }
    async getGeneratedListingDescription(unitId) {
        const response = await this.httpService.get(`${this.endpointBaseUrlV2}/listing-generator/${unitId}`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
}
exports.UnitListingDescriptionService = UnitListingDescriptionService;
//# sourceMappingURL=unit-listing-description.service.js.map